import { render } from "./PageIndexThree.vue?vue&type=template&id=a4a221f4"
import script from "./PageIndexThree.vue?vue&type=script&lang=js"
export * from "./PageIndexThree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__